import {Typography, Stack, Box, Link} from '@mui/material';
import MainCard from "../../../Components/MainCard";
import DataFlowDiagram from "../../../assets/images/getting-started/data-flow-diagram/data-flow-diagram.png"

function FAQInfo(){
    return (
        <MainCard>
            <Stack spacing={2.5}>
                <Typography variant="h4">
                    Frequently Asked Questions
                </Typography>
                <Typography variant="h6">
                    Do I need a Xero Subscription to use Ikigai?
                </Typography>
                <Typography variant="body1">
                    A number of applications within the Ikigai platform integrates with Xero. In order
                    to get the most use of these applications users will require a Xero subscription.
                    Ikigai is a platform that was built with Xero users in mind and its aim is to get
                    the best use out of Xero.
                </Typography>
                <Typography variant="h6">
                    What happens when I switch plans?
                </Typography>
                <Typography variant="body1">
                  When you switch plans, the time it takes to take effect, depends on whether it was an upgrade or a downgrade.
                  If it was an upgrade, changes will take effect immediately. If changes is a downgrade, changes will take effect at the
                    end of the billing period.
                </Typography>
                <Typography variant="h6">
                    Can I get a refund?
                </Typography>
                <Typography variant="body1">
                  All purchases are final and no refunds will be given.
                </Typography>
                <Typography variant="h6">
                    Who do I contact if something is not working or I need help?
                </Typography>
                <Typography variant="body1">
                    Please report all problems with the Ikigai platform to us. Please fill out the contact form <Link href="/contact-us">here</Link>.
                    Note, this contact us form is only available if you have an active account with Ikigai.
                    Please provide as much detail in the form as possible. We endeavour to respond to your e-mail
                    as soon as possible.
                </Typography>
                <Typography variant="h6">
                    What does this integration do? How does the data map to Xero?
                </Typography>
                <Typography variant="body1">
                    Ikigai integrates very closely with Xero API. At the moment it only fetches data and does not post any data back to Xero. Below is a data flow diagram that visualises the different endpoints that is used.
                    <Box
                        sx={{ position: 'relative', bottom: 0, right: 0 }}
                    >
                        <img style={{width:'100%', height: '100%'}} src={DataFlowDiagram} alt="Data Flow Diagram" />
                    </Box>
                </Typography>

            </Stack>
        </MainCard>
    )
}

export default FAQInfo;
